import React, { useEffect, useState } from 'react';
import './TeacherAwardFeedback.css';

// Preserve the attendance float and homework badge while sharing their lifecycle.
export default function TeacherAwardFeedback({ label, variant = 'float', studentName }) {
  const [visible, setVisible] = useState(true);
  const duration = variant === 'badge' ? 1800 : 1450;
  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);
  const announcement = label === '⭐ +2' ? '+2 DANDU Puanı' : label;
  return visible ? <span className={`teacher-award-feedback teacher-award-feedback--${variant}`}
    role="status" aria-label={studentName ? `${studentName}: ${announcement}` : announcement}>{label}</span> : null;
}
